const setLocks = ({ commit }, locks) => {
  commit('SET_LOCKS', locks || []);
};

const removeLock = ({ commit }, idPreSale) => {
  commit('REMOVE_LOCK', idPreSale);
};

export default {
  setLocks,
  removeLock
};
